import { hasPermission } from '@com/permission'
import Layout from '../views/layout/Layout'
import store from '@/store'

const playturboChildren = [
  {
    path: 'auth',
    name: 'warrant.playturbo.auth',
    component: () => import('@/views/warrant-manage/authorization.vue'),
    meta: {
      title: '授权管理',
      roles: ['grant.list'],
    },
  },
  {
    path: 'detail',
    name: 'warrant.playturbo.detail',
    component: () => import('@/views/warrant-manage/detail.vue'),
    meta: {
      title: '授权明细表',
      roles: ['grant.records'],
    },
  },
  {
    path: 'transaction',
    name: 'warrant.playturbo.transaction',
    component: () => import('@/views/warrant-manage/transaction.vue'),
    meta: {
      title: '订单&交易管理',
      roles: ['grant.account-balance'],
    },
  },
]

export default {
  path: '/warrant',
  component: Layout,
  redirect: 'noredirect',
  name: 'warrant',
  meta: {
    title: '授权管理',
    elicon: 'el-icon-fa-wrench',
    roles: [],
  },
  children: [
    {
      path: 'advertiser',
      name: 'warrant.advertiser',
      redirect: 'advertiser/auth',
      component: () =>
        import('@/views/butler/advertiser/adv-manager/index.vue'),
      meta: {
        title: '广告主管理',
        roles: [],
      },
      hiddenChildren: true,
      children: [
        {
          path: 'auth',
          component: () =>
            import('@/views/butler/advertiser/adv-manager/auth.vue'),
          meta: {
            title: '广告主管理',
            roles: ['advertiser.manage.list'],
          },
        },
        {
          path: 'test-account',
          component: () =>
            import('@/views/butler/advertiser/adv-manager/test-account.vue'),
          meta: {
            title: '测试账号管理',
            roles: ['advertiser.manage.test-account-list'],
          },
        },
      ],
    },
    {
      path: 'playturbo',
      name: 'warrant.playturbo',
      redirect: () => {
        const target = playturboChildren.find((item) =>
          hasPermission(item.meta.roles, 'or', store.getters.roles),
        )
        return { name: target.name }
      },
      component: () => import('@/views/warrant-manage/index.vue'),
      meta: {
        title: '广告主授权管理',
        roles: [], // 如果有子路由 roles，roles 必须配置为空数组
      },
      hiddenChildren: true,
      children: playturboChildren,
    },
    {
      path: 'bill',
      name: 'warrant.bill',
      redirect: 'bill/invoice',
      component: () => import('@/views/butler/bill/index.vue'),
      meta: {
        title: '月耗客户管理',
        roles: [], // 如果有子路由 roles，roles 必须配置为空数组
      },
      hiddenChildren: true,
      children: [
        {
          path: 'invoice',
          name: 'warrant.bill.invoice',
          component: () => import('@/views/warrant-manage/invoice.vue'),
          meta: {
            title: '发票管理',
            roles: ['finance.invoice.list'],
          },
        },
        {
          path: 'recharge',
          name: 'warrant.bill.recharge',
          component: () => import('@/views/warrant-manage/recharge.vue'),
          meta: {
            title: '充值记录表',
            roles: ['grant.recharge.list'],
          },
        },
        {
          path: 'balance',
          name: 'warrant.bill.balance',
          component: () => import('@/views/warrant-manage/balance.vue'),
          meta: {
            title: '用户账户余额表',
            roles: ['grant.account-balance'],
          },
        },
        {
          path: 'creative',
          name: 'warrant.bill.creative',
          component: () => import('@/views/butler/bill/creative/index.vue'),
          meta: {
            title: '创意消耗报表',
            roles: ['grant.account-balance'],
          },
        },
        {
          path: 'material',
          name: 'warrant.bill.material',
          component: () => import('@/views/butler/bill/material/index.vue'),
          meta: {
            title: '渠道包消耗报表',
            roles: ['grant.account-balance'],
          },
        },
      ],
    },
    {
      path: 'advertiser-account',
      name: 'warrant.advertiser.account',
      component: () => import('@/views/butler/advertiser/account.vue'),
      meta: {
        title: '广告主授权广告账号列表',
        roles: ['advertiser.ad-account.list'],
      },
    },
  ],
}
